import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5a16038"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "center" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "round" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_8 = { class: "inner" }
const _hoisted_9 = { class: "deal-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "status-text" }, [
    /*#__PURE__*/_createTextVNode("결제에 실패했어요 "),
    /*#__PURE__*/_createElementVNode("span", { class: "emoji" }, "😢")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createTextVNode(" 다른 구매자가 먼저 결제를 완료하여"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 결제가 불가능합니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 더 좋은 매물을 구매해보세요! ")
], -1))
const _hoisted_12 = {
  key: 1,
  class: "case-container"
}
const _hoisted_13 = { class: "wrapper" }
const _hoisted_14 = { class: "done-main" }
const _hoisted_15 = { class: "round" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_18 = { class: "inner" }
const _hoisted_19 = { class: "deal-name" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "status-text" }, "바로구매가 완료되었어요")
], -1))
const _hoisted_21 = { class: "pay-info" }
const _hoisted_22 = { class: "deal-center" }
const _hoisted_23 = { class: "price-info" }
const _hoisted_24 = { class: "deals-price" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "가격", -1))
const _hoisted_26 = { class: "div" }
const _hoisted_27 = { class: "bold regular" }
const _hoisted_28 = { class: "deals-percent" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "지분율", -1))
const _hoisted_30 = { class: "bold regular" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divide" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 결제 ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "price-info" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "deals-price" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "pay-name" }, "구매 지분 총액"),
      /*#__PURE__*/_createElementVNode("div", { class: "div" }, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", { class: "bold regular" }, "598,624,000"),
          /*#__PURE__*/_createTextVNode(" 원")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "deals-percent" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "pay-name" }, "지분율"),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "bold regular" }, "7,000"),
      /*#__PURE__*/_createTextVNode("P + "),
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, " 3,000 "),
      /*#__PURE__*/_createTextVNode(" 원")
    ])
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divide" }, null, -1))
const _hoisted_35 = { class: "final-info" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline done-money" }, "결제 완료 금액", -1))
const _hoisted_37 = { class: "inline big blue" }
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "remain-money" }, " 잔여 예수금 24,000 원 ", -1))
const _hoisted_41 = {
  key: 2,
  class: "container"
}
const _hoisted_42 = { class: "center" }
const _hoisted_43 = { class: "wrapper" }
const _hoisted_44 = { class: "main" }
const _hoisted_45 = { class: "round" }
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_48 = { class: "inner" }
const _hoisted_49 = { class: "deal-name" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "status-text" }, "조합원 등록 완료")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createTextVNode(" 어쩌구 저쩌구 하여 조합원 등록이 되었고"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 뭐뭐가 되었다"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 조합원으로서 뭐뭐를 할 수 있고"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 어떻게하면 되고 안 되고"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 자세한 확인은 조합규약에서 확인하세요 ")
], -1))
const _hoisted_52 = { class: "size" }
const _hoisted_53 = { class: "buttons-container" }
const _hoisted_54 = {
  key: 2,
  class: "two-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          (!_ctx.able && !_ctx.next)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("img", {
                          class: "img-circle img-responsive",
                          src: _ctx.stocks.companyLogo
                        }, null, 8, _hoisted_6),
                        _hoisted_7
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.deal.name), 1)
                      ]),
                      _hoisted_10
                    ]),
                    _hoisted_11
                  ])
                ])
              ]))
            : (_ctx.able && !_ctx.next)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          class: "img-circle img-responsive",
                          src: _ctx.stocks.logo
                        }, null, 8, _hoisted_16),
                        _hoisted_17
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.deal.name), 1)
                      ]),
                      _hoisted_20
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$filters.currency(_ctx.deal.price)) + " 원", 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.deal.percent) + " %", 1)
                      ])
                    ]),
                    _hoisted_31,
                    _hoisted_32,
                    _hoisted_33,
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("span", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$filters.currency(_ctx.deal.total)), 1),
                        _hoisted_39
                      ])
                    ]),
                    _hoisted_40
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("img", {
                            class: "img-circle img-responsive",
                            src: _ctx.stocks.logo
                          }, null, 8, _hoisted_46),
                          _hoisted_47
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.deal.name), 1)
                        ]),
                        _hoisted_50
                      ]),
                      _hoisted_51
                    ])
                  ])
                ]))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          (!_ctx.able && !_ctx.next)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "okay-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, " 확인 "))
            : (_ctx.able && !_ctx.next)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "okay-btn",
                  onClick: _cache[1] || (_cache[1] = () => {_ctx.next = !_ctx.next})
                }, " 조합원 등록 신청 "))
              : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("button", {
                    class: "move-btn okay-btn",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, " 내 자산 가기 "),
                  _createElementVNode("button", {
                    class: "okay-btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, " 구매 계속하기 ")
                ]))
        ])
      ])
    ]),
    _: 1
  }))
}